export default __webpack_public_path__ + "static/media/blackArrow.c779c7f4.svg";